document.addEventListener("DOMContentLoaded", () => {
    const windowEl = window;
    const isTouch =
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;

    const revealElements = document.querySelectorAll(".revealOnScroll");

    // Si es touch, animar todo directo
    if (isTouch) {
        revealElements.forEach((el) => {
            el.classList.add("animated");
        });
    }

    function revealOnScroll() {
        const scrolled = windowEl.scrollY;
        const winHeightPadded = windowEl.innerHeight * 1.1;

        // Mostrar elementos
        document
            .querySelectorAll(".revealOnScroll:not(.animated)")
            .forEach((el) => {
                const offsetTop =
                    el.getBoundingClientRect().top + window.scrollY - 150;
                const animation = el.dataset.animation;
                const timeout = el.dataset.timeout;

                if (scrolled + winHeightPadded > offsetTop) {
                    if (timeout) {
                        setTimeout(() => {
                            el.classList.add("animated", animation);
                        }, parseInt(timeout, 10));
                    } else {
                        el.classList.add("animated", animation);
                    }
                }
            });

        // Ocultar elementos
        document.querySelectorAll(".revealOnScroll.animated").forEach((el) => {
            const offsetTop = el.getBoundingClientRect().top + window.scrollY;
            const animation = el.dataset.animation;

            if (scrolled + winHeightPadded < offsetTop) {
                el.classList.remove("animated", animation);
            }
        });
    }

    windowEl.addEventListener("scroll", revealOnScroll);

    // Ejecutar al cargar
    revealOnScroll();
});
